webpackJsonp([3],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/vue-todo-app-7-summary.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<p>This tutorial showed some of the advanced aspects of building a rich application over a hypermedia API:</p>\n<ul>\n<li>bookmarkable URIs hold state and you’ll need to develop your strategy early on for client-side urls and routing</li>\n<li>being able to reconstruct client state (that in practice is performs) tends to require a client-side application cache that views can bind to</li>\n<li>with the two above, users can enter the application anywhere which means that you’ll need good on-demand authentication and be able to replay requests</li>\n<li>updating and cloning data needs to occur using the same code and a hypermedia application that has forms (aka affordances) makes this pretty straightforward</li>\n</ul>\n<p>That’s it!</p>",
				"fields": {
					"slug": "/vue-todo-app/7-summary/"
				},
				"excerpt": "This tutorial showed some of the advanced aspects of building a rich application over a hypermedia API: bookmarkable URIs hold state and you...",
				"frontmatter": {
					"title": "Summary",
					"videoId": null,
					"videoAuthor": null,
					"parent": "/Users/todd/src/howtohypermedia/content/frontend/vue-todo-app/7-summary.md absPath of file",
					"question": "Did you find this tutorial useful?",
					"answers": [
						"What tutorial?",
						"Yes, I learned something!",
						"No, I even forgot what I knew before!",
						"Too confusing!"
					],
					"correctAnswer": 1,
					"description": "Learn how to build a todo app over the top of a hypermedia API",
					"pageTitle": "Building a rich todo app tutorial"
				}
			},
			"mds": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"title": "Get started with your favorite technology",
								"description": null
							},
							"fields": {
								"slug": "/choose/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Update Collection Resource",
								"description": "Learn the code mechanics of a edit forms on a collection resource that uses different mime-types"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/11-update-collection/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "It was great having you!",
								"description": null
							},
							"fields": {
								"slug": "/success/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Update Singleton Resource",
								"description": "Learn the code mechanics of a edit forms on a singleton resource"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/10-update-singleton/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a hypermedia API that works within the constraints of REST"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to build a hypermedia API "
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "",
								"description": null
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/2-modelling-representations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Modelling Domain",
								"description": "Learn how to diagram the API textually and get also get visual output"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/3-modelling-domain-link-relations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Representations",
								"description": "Learn the code mechanics of request/response of representation in an MVC framework with the root API representation containing links and a version"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/4-constructing-representations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Collections",
								"description": "Learn the code mechanics of a singleton resource with the user resource"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/6-constructing-collection/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Searchable Resources",
								"description": "Learn the code mechanics of a search forms on a collection"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/8-constructing-search-resources/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Singletons",
								"description": "Learn the code mechanics of a singleton resource with the user resource"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/5-constructing-singleton/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Create Resource",
								"description": "Learn the code mechanics of a create forms on a collection"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/9-create-resource/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Virtual Resource",
								"description": "Learn the code mechanics of a virtual resource with the user resource"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/7-constructing-viritual/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a todo app and admin functions over the top of a hypermedia API"
							},
							"fields": {
								"slug": "/vue-todo-app/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Client-side URLs and routing",
								"description": "Design your application around the holding and reconstructing client state through the URI in the browser location requires matching client views and the data it requires"
							},
							"fields": {
								"slug": "/vue-todo-app/2-client-side-urls-and-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting started",
								"description": "Learn how to build a todo client to use the hypermedia API "
							},
							"fields": {
								"slug": "/vue-todo-app/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Client-side application cache",
								"description": "Client need to have one copy of representations in the application cache"
							},
							"fields": {
								"slug": "/vue-todo-app/3-application-cache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Updates and deletes",
								"description": "The application cache also deals with the updates and deletion of resources"
							},
							"fields": {
								"slug": "/vue-todo-app/4-updates-and-deletes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "On-demand Authentication",
								"description": "Be able to create and renew authentication tokens when the server requests valid authentication tokens"
							},
							"fields": {
								"slug": "/vue-todo-app/5-on-demand-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "Learn how to build a todo app over the top of a hypermedia API"
							},
							"fields": {
								"slug": "/vue-todo-app/7-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to build a general purpose client to browse over the API "
							},
							"fields": {
								"slug": "/vue-api-browser/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Cloning Resources",
								"description": "Forms in hypermedia make cloning of trees straightforward and we can leverage that with drag and drop functionality alongside the client-side application cache"
							},
							"fields": {
								"slug": "/vue-todo-app/6-cloning-resources/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "HTML representation",
								"description": "Learn what and why to build HTML representation of data with code on demand"
							},
							"fields": {
								"slug": "/vue-api-browser/2-build-html-representation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a general purpose client to browse over the API "
							},
							"fields": {
								"slug": "/vue-api-browser/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Generate HTML",
								"description": "Learn how to respond as HTML in ASP.NET Core"
							},
							"fields": {
								"slug": "/vue-api-browser/3-build-html-content-negotiation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Register text/html",
								"description": "Learn how to respond to HTML content negotiation in ASP.NET Core"
							},
							"fields": {
								"slug": "/vue-api-browser/4-register-html-content-negotiation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "GET application/json",
								"description": "Learn how to request JSON from the client"
							},
							"fields": {
								"slug": "/vue-api-browser/5-request-json/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "Learn how to user hypermedia as engine to navigate an API and make changes"
							},
							"fields": {
								"slug": "/vue-api-browser/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Displaying with interaction",
								"description": "Learn how to process JSON to make delete, create and update"
							},
							"fields": {
								"slug": "/vue-api-browser/6-displaying-with-interaction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Displaying forms",
								"description": "Learn how to process form values for create and edit forms"
							},
							"fields": {
								"slug": "/vue-api-browser/8-displaying-form-values/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deleting a resource",
								"description": "Learn how to process JSON to try and delete a resource"
							},
							"fields": {
								"slug": "/vue-api-browser/7-try-delete-representation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn all about hypermedia and why a REST-style of architecture is simple and subtle. It's not really for the lazy or those who like to be clever."
							},
							"fields": {
								"slug": "/basics/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Minimally layered design",
								"description": "Learn why hypermedia is a thin layer across persistence that should guide us through the business problem."
							},
							"fields": {
								"slug": "/basics/1-minimally-layered-design/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Submitting forms",
								"description": "Learn how to process creates (POST) and updates (PUT) on a resource"
							},
							"fields": {
								"slug": "/vue-api-browser/9-submitting-forms/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Big Picture (Trends)",
								"description": "Learn that distributed applications have trended towards data and business logic being processed at the client edge"
							},
							"fields": {
								"slug": "/basics/3-big-picture/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Hypermedia for the dedicated",
								"description": "Learn some techniques that will ease the server and client development"
							},
							"fields": {
								"slug": "/basics/4-for-the-dedicated/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Navigating a hypermedia API",
								"description": "Learn what a hypermedia looks like to be able to explore a domain."
							},
							"fields": {
								"slug": "/basics/2-navigating-api/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Multiple clients",
								"description": "Learn that most APIs should have multiple types of clients."
							},
							"fields": {
								"slug": "/advanced/0-multiple-clients/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "API Modelling",
								"description": "Learn about how collections and singletons are modelled in hypermedia"
							},
							"fields": {
								"slug": "/advanced/1-api-modelling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Forms Modelling",
								"description": "Links and Forms are used to update resources and controlled by the server that the client then uses"
							},
							"fields": {
								"slug": "/advanced/2-forms-modelling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Common Questions",
								"description": "Answer common questions about these tutorials"
							},
							"fields": {
								"slug": "/advanced/4-common-questions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Todo Domain",
								"description": "Learn about domain of the API"
							},
							"fields": {
								"slug": "/advanced/3-todo-domain/"
							}
						}
					}
				]
			}
		},
		"pathContext": {
			"slug": "/vue-todo-app/7-summary/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---vue-todo-app-7-summary-dcdf8e4ecc41be98af9b.js